import {calendarV2} from "./api.calendarV2";
import {api_notifications} from "./api.notifications";
import {analytic_doctor} from "./analytic_doctor";
import {analytic_places} from "./analytic_places";

export const API_VerificationCenter = {
    notifications: api_notifications,
    calendarV2: calendarV2,
    analytic_doctor,
    analytic_places
}